<template>
    <div v-if="vehicle_stock_info && vehicle_stock_info.sold && vehicle_stock_info.sold.json && vehicle_stock_info.sold.json.inspection && $userIsSuperAdmin()"
       title="Inspection">
        <div class="pull-right col-md-4" v-if="show_image">
            <el-image
                    v-if="vehicle_stock_info.sold.json.inspection.sheet"
                    :src="vehicle_stock_info.sold.json.inspection.sheet"
                    ></el-image>
        </div>
        <strong>Heiwa ID</strong>: {{vehicle_stock_info.sold.json.vid}} <br />
        <strong>Inspected Mileage</strong>: {{formatNumber(vehicle_stock_info.sold.json.inspection.main.mileaget)}} km <br />
        <table class="table table-bordered inspection-table">
            <tr>
                <td>AC</td><td> <span v-html="showInspectionValue('main.ac')"></span></td>
                <td>PS</td><td> <span v-html="showInspectionValue('main.ps', true)"></span></td>
                <td>PW</td><td> <span v-html="showInspectionValue('main.pw', true)"></span></td>
                <td>AB</td><td> <span v-html="showInspectionValue('main.ab')"></span></td>
                <td>ABS</td><td> <span v-html="showInspectionValue('main.abs', true)"></span></td>
                <td>Fuel</td><td> <span v-html="showInspectionValue('main.fuel')"></span></td>
            </tr>
            <tr>
                <td>AW</td><td> <span v-html="showInspectionValue('main.aw')"></span></td>
                <td>SR</td><td> <span v-html="showInspectionValue('main.sr', true)"></span></td>
                <td>CD</td><td> <span v-html="showInspectionValue('main.cd', true)"></span></td>
                <td>Seat</td><td> <span v-html="showInspectionValue('main.seat')"></span></td>
                <td>TV</td><td> <span v-html="showInspectionValue('main.tv', true)"></span></td>
                <td>NAVI</td><td> <span v-html="showInspectionValue('main.navi', true)"></span></td>
            </tr>
            <tr>
                <td>Leather</td><td> <span v-html="showInspectionValue('main.leather', true)"></span></td>
                <td>One Owner</td><td> <span v-html="showInspectionValue('main.oneowner', true)"></span></td>
                <td>Easy Closer</td><td> <span v-html="showInspectionValue('main.easycloser', true)"></span></td>
                <td>Auto Door</td><td> <span v-html="showInspectionValue('main.autodoor', true)"></span></td>
                <td>Back Monitor</td><td> <span v-html="showInspectionValue('main.backmonitor', true)"></span></td>
                <td>Smart Key</td><td> <span v-html="showInspectionValue('main.smartkeysystem', true)"></span></td>
            </tr>
            <tr>
                <td>Cruise Control</td><td> <span v-html="showInspectionValue('main.cruisecontrol', true)"></span></td>
                <td>Steering</td><td> <span v-html="showInspectionValue('main.steeringstyle')"></span></td>
                <td>Turbo</td><td> <span v-html="showInspectionValue('main.turbo', true)"></span></td>
                <td>Timing</td><td> <span v-html="showInspectionValue('main.timing')"></span></td>
                <td>if replaced</td><td> <span v-html="showInspectionValue('main.fffff')"></span></td>
                <td>Capacity</td><td> <span v-html="showInspectionValue('main.capacity')"></span></td>
            </tr>
        </table>
        <table class="table table-bordered inspection-table">
            <tr>
                <td width="100">MEMO</td><td> <span v-html="showInspectionValue('main.memo')"></span></td>
            </tr>
            <tr>
                <td>BODY</td><td> <span v-html="showInspectionValue('body')"></span></td>
            </tr>
            <tr>
                <td>INTERIOR</td>
                <td>
                    <ul v-if="showInspectionList('interior')">
                        <li v-for="item in showInspectionList('interior')">
                            {{item}}
                        </li>
                    </ul>
                </td>
            </tr>
            <tr>
                <td>AM PARTS</td>
                <td>
                    <ul v-if="showInspectionList('am_parts')">
                        <li v-for="item in showInspectionList('am_parts')">
                            {{item}}
                        </li>
                    </ul>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
    import {objLookup, numberWithCommas} from '../../util/common'

    export default {
        props: [
            'vehicle_stock_info',
            'show_image'
        ],
        data() {
            return {
            }
        },
        computed: {
            soldData(){
                if (this.vehicleStockData && this.vehicleStockData.sold && this.vehicleStockData.sold.json) {
                    return this.vehicleStockData.sold.json;
                }
                return {}
            }
        },
        methods: {
            showInspectionValue(key, bool) {
                let value = objLookup(this.vehicle_stock_info, `sold.json.inspection.${key}`)
                if (typeof value === 'undefined') {
                    return ''
                }
                if (value === 'NO' || value === 'YES') {
                    let icon = value === 'YES' ? 'fa-check text-success' : 'fa-times text-danger'
                    return `<i class="fa ${icon}"></i>`
                } else if (bool) {
                    return value ? value : '?'
                }
                return value
            },
            formatNumber(val) {
                return numberWithCommas(val);
            },
            showInspectionList(key) {
                let value = objLookup(this.vehicle_stock_info, `sold.json.inspection.${key}`)
                if (typeof value === 'undefined' || !value) {
                    return false
                }
                if (value.indexOf('|') !== -1) {
                    return value.split('|')
                }
                return value ? [value] : false
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/VehicleStock/Inspection.vue